<template>
  <el-dialog custom-class="dialog-container"
             :visible.sync="show"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :show-close="false"
             width="600px"
             top="5vh">
    <div class="account-container">
      <img class="account-img"
           :src="require(`../../assets/pics/account-${language==='cn'? 'cn':'en'}.png`)"
           alt="" />
      <div class="close-button"
           @click="closeDialog">X</div>

    </div>
  </el-dialog>
</template>

<script>
export default {
  inject: ['gridTemplate'],
  data () {
    return {
    };
  },
  props: {
    show: Boolean,
    language: String,
  },
  methods: {
    closeDialog () {
      this.gridTemplate.hideAccountDialog();
    },
  },
};
</script>

<style lang="scss" scoped>
.account-container {
  position: relative;
  .account-img {
    width: 600px;
    height: 500px;
  }
  .close-button {
    position: absolute;
    right: 13px;
    top: 11px;
    width: 30px;
    height: 30px;
    border-radius: 30px;
    cursor: pointer;
    border: 2px solid #fff;
    text-align: center;
    line-height: 30px;
    color: #fff;
    font-size: 16px;
  }
}
</style>
